import request from '../../src/state/modules/axios'

export function getPositionLevels(data){
 return request({
     url: '/api/position/levels',
     method: 'get',
     params: data,
 })
}

export function addPositionLevel(data){
    return request({
     url: '/api/position/levels',
     method: 'post',
        data,
    })
}

export function editPositionLevel(data){
    return request({
        url: `/api/position/levels/${data.id}`,
        method: 'put',
        data,
    })
}
export function getLevelById(data){
    return request({
        url: `/api/position/levels/${data.id}`,
        method: 'get',
    })
}
export function createLevelById(){
    return request({
        url : `/api/position/levels`,
        method: 'get'
    })
}

export function deletePositionLevel(data){
    return request({
        url: `/api/position/levels/${data.id}`,
        method: 'delete'
    })
}

export function getPositions(params){
    return request({
        url: '/api/position/index',
        method: 'get',
        params
    })
}

export  function addPosition(data){
    return request({
        url: '/api/position/index',
        method: 'post',
        data
    })
}
export function editPosition(data){
    return request({
        url: `/api/position/index/${data.id}`,
        method: 'put',
        data,
    })
}
export function getPositionById(data){
    return request({
        url: `/api/position/index/${data.id}`,
        method: 'get',
    })
}

export function createPositionById(){
    return request({
        url : `/api/position/index`,
        method: 'get'
    })
}

export function deletePosition(data){
    return request({
        url: `/api/position/index/${data.id}`,
        method: 'delete'
    })
}

export function changeTestStatus(data){
    return request({
        url: '/api/test/change-status',
        method:'post',
        data,
    })
}
